import {Layout, Typography} from "antd";
import {Content, Footer} from "antd/es/layout/layout";
import {Outlet} from "react-router-dom";
import "./BaseLayout.css"
import {Breadcrumbs} from "./components/breadcrumb/Breadcrumbs";
import HeaderLayout from "./components/HeaderLayout";
import {RequiredAuth} from "./components/RequiredAuth";

const { Text } = Typography;
export function BaseLayout(){
    return <>
        <RequiredAuth>
            <Layout>
                <HeaderLayout></HeaderLayout>
                <Breadcrumbs></Breadcrumbs>

                <Content className={"content"}>
                    <Outlet/>
                </Content>
                <Footer className={"footer"}>
                    {/*<Text italic>Featured By Manydesing</Text>*/}
                </Footer>
            </Layout>
        </RequiredAuth>
    </>
}